import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Plus as PlusIcon } from '@phosphor-icons/react/dist/ssr/Plus';
import type Framework from 'benchmarking-domain/framework';
import { FrameworksTable } from 'components/admin/frameworks/frameworks-table';
import useApi from 'hooks/use-api';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

export default function Frameworks(): React.JSX.Element {
  const navigate = useNavigate();

  const { subscribeFrameworks } = useApi();
  const [frameworks, setFrameworks] = useState<Framework[]>([]);

  useEffect(() => {
    const unsubscribe = subscribeFrameworks(false, (fetchedFrameworks) => {
      setFrameworks(fetchedFrameworks?.sort((one, two) => (one.name < two.name ? -1 : 1)));
    });

    return () => {
      unsubscribe();
    };
  }, [subscribeFrameworks]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
          <Typography variant="h4">Frameworks</Typography>
        </Stack>
        <div>
          <Button
            startIcon={<PlusIcon fontSize="var(--icon-fontSize-md)" />}
            variant="contained"
            onClick={() => {
              navigate(paths.app.admin.frameworks.add);
            }}
          >
            Add
          </Button>
        </div>
      </Stack>

      <FrameworksTable rows={frameworks} />
    </Stack>
  );
}
